import React from 'react';
import { Phone, CheckCircle, Wrench, AlertTriangle, DollarSign } from 'lucide-react';
export function PowerStroke73LPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7948">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7949">
        <div className="container mx-auto px-4" data-id="element-7950">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7951">
            Ford 7.3L PowerStroke Engine Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7952">
            Maintenance, Inspection, Diagnostics, and Repair
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7953">
        <div className="max-w-4xl mx-auto" data-id="element-7954">
          {/* Three Engine Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7955">
            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-7956">
              <div className="text-center" data-id="element-7957">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/7.3.jpg?opt=w3" alt="Ford 7.3 liter Powerstroke Diesel engines repaired" title="7.3 liter power stroke engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7958" />
                <p className="text-lg font-bold text-gray-900" data-id="element-7959">
                  7.3 Power Stroke
                </p>
                <p className="font-semibold text-green-700 mt-2" data-id="element-7960">The "Good"</p>
              </div>

              <div className="text-center" data-id="element-7961">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/6.0l.jpg?opt=w3" alt="How to repair your powerstroke engine from Ford Motor Company" title="6.0 Powerstroke Engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7962" />
                <a href="/services/powerstroke-6-0" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7963">
                  6.0 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7964">The "Bad"</p>
              </div>

              <div className="text-center" data-id="element-7965">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/imagesCAB65B34.jpg?opt=w3" alt="Common problems and repairs for Ford Powerstroke Diesel Engines" title="6.4 Liter Power Stroke Engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7966" />
                <a href="/services/powerstroke-6-4" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7967">
                  6.4 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7968">The "Ugly"</p>
              </div>
            </div>
          </div>

          {/* Service Banner */}
          <div className="bg-[#910808] text-white rounded-lg shadow-md p-8 mb-8 text-center" data-id="element-7969">
            <h2 className="text-2xl font-bold" data-id="element-7970">
              Ford 7.3L PowerStroke engine maintenance, inspection, diagnostics,
              and repair.
            </h2>
          </div>

          {/* Engine History */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7971">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-7972">
              7.3 liter Power Stroke Engine
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-7973">
              7.3 Powerstroke
            </h3>

            <p className="text-gray-700 mb-4" data-id="element-7974">
              The first 7.3L was produced from 1988-1993. The original 7.3L
              diesel was a non-turbo charged indirect injection (IDI) engine,
              followed shortly after by a turbo charged version. It was very
              similar to the previous 6.9l IDI diesel engine, which was simply
              bored out for more torque. This engine is not considered in the
              powerstroke family. In 1994, the 7.3L underwent some changes. The
              7.3L was changed to a direct injection (DI) engine from the
              original IDI engine.
            </p>

            <p className="text-gray-700 mb-4" data-id="element-7975">
              Ford also added electronic fuel injectors and gave it the name
              Power Stroke. This model produced up to 250 hp (190 kW) and 525
              lb·ft (712 N·m) of torque. The new 7.3L DI Power stroke had
              "single shot" HEUI (hydraulic electronic unit injectors) fuel
              injectors and ran a 15º high pressure oil pump (HPOP) to create
              fuel injection pressures. The turbine housing was a 1.15 A/R. In
              1999, an air to air intercooler was added. The intercooler cooled
              the charged air from the turbo making it denser. The cooler,
              denser air would increase the horsepower potential of the engine,
              while also reducing exhaust gas temperatures (EGTs). The turbine
              housing was changed to a .84 A/R housing and a wastegate was
              added.
            </p>

            <p className="text-gray-700 mb-6" data-id="element-7976">
              The "single shot" HEUI injectors were upgraded to "split shot"
              injectors. With larger injectors, the HPOP was advanced to 17º to
              increase fuel pressures. The 7.3L DI Power Stroke was in
              production up until 2004 when it was replaced by the 6.0L. The 7.3
              IDI and 7.3 Powerstroke are not the same engine at all except
              manufactured by International for Ford.
            </p>

            <div className="bg-green-50 border-l-4 border-green-500 p-6" data-id="element-7977">
              <p className="text-gray-800 font-bold text-lg" data-id="element-7978">
                This is known to be the longest lasting and most reliable
                powerstroke engine.
              </p>
            </div>
          </div>

          {/* Common Issues and Repairs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7979">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-7980">
              Common 7.3L Issues and Repairs
            </h2>

            <div className="space-y-6" data-id="element-7981">
              {/* IPR Valve */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7982">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7983">
                  <Wrench className="mr-2 text-[#B1050B]" size={20} data-id="element-7984" />
                  IPR Valve
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7985">
                  The IPR VALVE is located in the valley on the HPOP. These
                  often stick, sensors go bad or the wires can corrode or get
                  cut.
                </p>
                <p className="text-gray-600 italic" data-id="element-7986">Replacement required.</p>
              </div>

              {/* IDM */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7987">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7988">
                  <Wrench className="mr-2 text-[#B1050B]" size={20} data-id="element-7989" />
                  IDM (Injector Driver Module)
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7990">
                  IDM located on drivers side fender can go bad and will cause a
                  no-start or rough running and cut outs in revving/rpm.
                </p>
                <p className="text-gray-600 italic" data-id="element-7991">Replacement required.</p>
              </div>

              {/* CPS Sensor */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7992">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7993">
                  <AlertTriangle className="mr-2 text-red-600" size={20} data-id="element-7994" />
                  Bad CPS Sensor
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7995">
                  Bad CPS sensor causes the engine to cut out and eventually
                  stop running. The engine will not start until it sits for
                  extended period or is reset by disconnecting batteries for a
                  period of time.
                </p>
                <p className="text-gray-600 italic" data-id="element-7996">
                  Requires replacement when bad. We use OEM as aftermarket CPS
                  sensors can be defective out of the box.
                </p>
              </div>

              {/* UVCH Connectors */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7997">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7998">
                  <AlertTriangle className="mr-2 text-red-600" size={20} data-id="element-7999" />
                  Bad UVCH Connectors
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8000">
                  These can ground out on your glow plugs, causing rough running
                  conditions, resulting in a rocking motion of the truck and
                  will often sputter and die. There are four connectors on your
                  block/heads located under the valve covers.
                </p>
                <p className="text-gray-600 italic" data-id="element-8001">
                  Physically inspect them by unplugging and check for cut wires
                  or burned connectors. If there is any damage, replacement is
                  necessary.
                </p>
              </div>

              {/* Clogged Fuel Filter */}
              <div className="border-l-4 border-green-500 pl-6" data-id="element-8002">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-8003">
                  <CheckCircle className="mr-2 text-green-600" size={20} data-id="element-8004" />
                  Clogged Fuel Filter
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8005">
                  Clogged fuel filter will often cause long cranking or slight
                  loss in power, since the injectors can't get the fuel they
                  need to keep the engine running properly.
                </p>
                <p className="text-green-700 font-semibold" data-id="element-8006">
                  Replacing fuel filter is routine maintenance and can save you
                  aggravation, time and money.
                </p>
              </div>

              {/* Lift Pump Failure */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-8007">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-8008">
                  <Wrench className="mr-2 text-[#B1050B]" size={20} data-id="element-8009" />
                  Lift Pump Failure
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8010">
                  Lift pump failure will cause a no-start situation. If the lift
                  pump is inspected and determined to be the cause of no-start,
                  replacement is necessary.
                </p>
              </div>

              {/* Engine Overheating */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-8011">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-8012">
                  <AlertTriangle className="mr-2 text-red-600" size={20} data-id="element-8013" />
                  Engine Overheating
                </h3>
                <p className="text-gray-700" data-id="element-8014">
                  Engine overheating can be caused by bad radiator, bad
                  thermostat, bad water pump, or bad coolant.
                </p>
              </div>

              {/* Bad ICP Sensor */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-8015">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-8016">
                  <Wrench className="mr-2 text-[#B1050B]" size={20} data-id="element-8017" />
                  Bad ICP Sensor
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8018">
                  A bad ICP sensor will cause the engine to cut in and out,
                  often stops running altogether and may not restart.
                </p>
                <p className="text-gray-600 italic" data-id="element-8019">
                  Diagnosis and replacement is necessary if found to be bad.
                </p>
              </div>
            </div>
          </div>

          {/* Additional Common Issues */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8020">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-8021">
              Additional Common Issues
            </h2>

            <div className="space-y-6" data-id="element-8022">
              {/* Climate Control Hissing */}
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-8023">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-8024">
                  Climate Control Hissing
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8025">
                  Hissing from the dash when on "Max A/C" or "Defrost" selection
                  is made on the Climate Control Selector. Open the hood and
                  look to the back left (as you are looking at the motor) of the
                  Engine Bay. Near the firewall and right fender there is a vent
                  blending door actuated by a white (factory) 1/8" vacuum line.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-8026">
                  <strong data-id="element-8027">Fix:</strong> Inspect for dry/cracking/broken vacuum
                  line and replace. Hissing under the dash will go away.
                </p>
                <div className="flex items-center text-green-700 font-semibold" data-id="element-8028">
                  <DollarSign size={18} className="mr-1" data-id="element-8029" />
                  <span data-id="element-8030">Easy Fix - Cost: $10</span>
                </div>
              </div>

              {/* Fuel Heater */}
              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-8031">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-8032">
                  Fuel Heater
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8033">
                  Fuel heater shorts out and blows maxifuse #22, disabling the
                  PCM. Disconnect the fuel heater, replace fuse, re-try start.
                </p>
                <div className="flex items-center text-green-700 font-semibold" data-id="element-8034">
                  <DollarSign size={18} className="mr-1" data-id="element-8035" />
                  <span data-id="element-8036">
                    Replacement cost: $3 for the fuse (always carry spare fuses,
                    including maxifuses, in the glove box)
                  </span>
                </div>
              </div>

              {/* Glow Plugs */}
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-8037">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-8038">
                  Glow Plugs
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8039">
                  Usual tests for GP relay function, UVCH continuity, resistance
                  of the glow plugs.
                </p>
                <p className="text-gray-600 italic" data-id="element-8040">
                  Replacement cost depends on what's found to be defective.
                </p>
              </div>

              {/* Block Heater */}
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-8041">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-8042">
                  Block Heater
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8043">
                  Usually it's just the cord, not the heater itself. Test with
                  an ohmmeter / continuity tester.
                </p>
                <div className="flex items-center text-green-700 font-semibold" data-id="element-8044">
                  <DollarSign size={18} className="mr-1" data-id="element-8045" />
                  <span data-id="element-8046">
                    Replacement cost: $20-30 for a generic cord that fits our
                    heaters, available at NAPA
                  </span>
                </div>
              </div>

              {/* Coolant SCA Maintenance */}
              <div className="bg-red-50 rounded-lg p-6" data-id="element-8047">
                <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center" data-id="element-8048">
                  <AlertTriangle className="mr-2 text-red-600" size={20} data-id="element-8049" />
                  Coolant SCA Maintenance (CRITICAL)
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-8050">
                  SCA degradation results eventually in cavitation.
                </p>
                <p className="text-red-700 font-bold mb-2" data-id="element-8051">
                  Repair cost - you don't want to know (engine replacement)
                </p>
                <div className="bg-green-100 border-l-4 border-green-500 p-4 mt-3" data-id="element-8052">
                  <p className="text-gray-800 font-semibold mb-1" data-id="element-8053">
                    Prevention:
                  </p>
                  <ul className="list-disc list-inside text-gray-700" data-id="element-8054">
                    <li data-id="element-8055">
                      $20-ish for a bottle of SCA and some test strips if
                      coolant is still fresh
                    </li>
                    <li data-id="element-8056">$100+ for complete coolant flush</li>
                  </ul>
                </div>
              </div>

              {/* Clutch Linkage/Hydraulics */}
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-8057">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-8058">
                  Clutch Linkage/Hydraulics Issues
                </h3>
                <p className="text-gray-700 mb-3" data-id="element-8059">
                  Weak hydraulics, or worn pedal box bushings, or worn lever arm
                  / eyelet bushing. Extreme eyelet bushing wear can lead to the
                  eyelet expanding (ovalizing).
                </p>
                <div className="space-y-1 text-gray-700" data-id="element-8060">
                  <p data-id="element-8061">
                    <strong data-id="element-8062">Repair/Replacement costs:</strong>
                  </p>
                  <ul className="list-disc list-inside ml-4" data-id="element-8063">
                    <li data-id="element-8064">
                      $120-150 for the hydraulics (complete pre-bled system)
                    </li>
                    <li data-id="element-8065">$20 for the pedal box bushings (dealer)</li>
                    <li data-id="element-8066">
                      $5 for the "cheap" arm/eyelet bushing repair (brass tubing
                      + drill stop collar)
                    </li>
                    <li data-id="element-8067">$20 for the "fancy" arm/eyelet bushing repair</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Why 7.3L is "The Good" */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8068">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-8069">
              Why the 7.3L is "The Good"
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-8070">
              <div className="bg-green-50 rounded-lg p-6" data-id="element-8071">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-8072">
                  Strengths:
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-8073">
                  <li className="flex items-start" data-id="element-8074">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-8075" />
                    <span data-id="element-8076">Longest lasting Powerstroke engine</span>
                  </li>
                  <li className="flex items-start" data-id="element-8077">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-8078" />
                    <span data-id="element-8079">Most reliable Powerstroke design</span>
                  </li>
                  <li className="flex items-start" data-id="element-8080">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-8081" />
                    <span data-id="element-8082">Simple, proven technology</span>
                  </li>
                  <li className="flex items-start" data-id="element-8083">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-8084" />
                    <span data-id="element-8085">Easier to diagnose and repair</span>
                  </li>
                  <li className="flex items-start" data-id="element-8086">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-8087" />
                    <span data-id="element-8088">Lower repair costs overall</span>
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-6" data-id="element-8089">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-8090">
                  Common Maintenance:
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-8091">
                  <li className="flex items-start" data-id="element-8092">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-8093">
                      •
                    </span>
                    <span data-id="element-8094">Regular fuel filter changes</span>
                  </li>
                  <li className="flex items-start" data-id="element-8095">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-8096">
                      •
                    </span>
                    <span data-id="element-8097">Coolant SCA testing and maintenance</span>
                  </li>
                  <li className="flex items-start" data-id="element-8098">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-8099">
                      •
                    </span>
                    <span data-id="element-8100">Sensor inspections (CPS, ICP, IPR)</span>
                  </li>
                  <li className="flex items-start" data-id="element-8101">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-8102">
                      •
                    </span>
                    <span data-id="element-8103">UVCH connector checks</span>
                  </li>
                  <li className="flex items-start" data-id="element-8104">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-8105">
                      •
                    </span>
                    <span data-id="element-8106">Glow plug system maintenance</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-8107">
            <h2 className="text-3xl font-bold mb-4" data-id="element-8108">
              Expert 7.3L Powerstroke Service
            </h2>
            <p className="text-xl mb-6" data-id="element-8109">
              Keep your reliable 7.3L running strong with professional
              maintenance and repair
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8110">
              <Phone className="mr-3" size={24} data-id="element-8111" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-8112">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}